<template>
  <div>
    <h1 class="text-center">
      {{ schema.$title }}
    </h1>

    <panel>
      <div class="row form-group">
        <w-input class="col-md-8" :model="schema.data.school.schoolName" :disabled="true" />

        <w-input class="col-md-4" :model="schema.data.schoolYear" />
      </div>
    </panel>

    <panel>
      <student :schema="schema">
        <template v-slot:contest="{ contest }">
          <div class="alert alert-info mt-5">
            <h3>{{ contest.assessment.$title }}</h3>

            <div class="row form-group">
              <yes-or-no class="col-md-6" :model="contest.assessment.distinction" />

              <yes-or-no class="col-md-6" :model="contest.assessment.scholarship" />

              <w-input class="col-12" :model="contest.assessment.scholarshipAmount" />
            </div>
          </div>
        </template>

        <panel slot="after">
          <div class="row form-group">
            <w-input
              class="col-12 mb-3"
              :model="schema.data.scholarshipAmountTotal"
              :disabled="schema.data.contestType.$model === 2"
            />

            <w-textarea class="col-12" :model="schema.data.itemName" />

            <w-textarea class="col-12" :model="schema.data.itemComment" />
          </div>
        </panel>
      </student>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel';
import { ow003PrezydenckiMixin } from '@/mixins/document/ow003Prezydencki';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';
import Student from '../Student';
import YesOrNo from '../YesOrNoRadio.vue';

// @vuese
// Formularz wzoru OW-003-Prezydencki
export default {
  components: { Panel, Student, YesOrNo, ...components },
  mixins: [ow003PrezydenckiMixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  }
};
</script>
